<template>
  <div>
    <b-row>
      <b-col v-for="item in items" :key="item.id" cols="3">
        <template v-if="item.change > 1">
          <b-card :title="item.name" bg-variant="success">
            <b-card-body>
              {{ item.mean }}
              
               <line-chart :chart-data="getLineChart(item)" />
            
            </b-card-body>
          </b-card>
        </template>
        <template v-else>
          <b-card :title="item.name" bg-variant="danger">
            <b-card-body>
              {{ item.mean }}
               <line-chart :chart-data="getLineChart(item)" />
            </b-card-body>
          </b-card>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import LineChart from "../components/LineChart";
export default {
    components: { LineChart },
  data() {
    return {
      chartdata: [],
      loaded: false,
      items: [],
      fields: [
        {
          key: "icon",
          sortable: false,
        },
        {
          key: "change",
          sortable: true,
        },
        {
          key: "mean",
          sortable: true,
        },
      ],
    };
  },
  mounted() {
    axios
      .get(
        "https://api.poe.watch/get?category=currency&league=" +
          this.$parent.league
      )
      .then((res) => {
        this.items = res.data;
      });
  },
  methods: {
    getLineChart(item) {
      return {
            labels: ["1", "2", "3"],

            datasets: [
              {
                label: item.name,
                borderWidth: 1,
                fill: true,
                data: item.history,
                borderColor: "#3cba9f",
              },
            ],
          };
    },
  },
};
</script>